import useAuthStore from "@/store/auth";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding")({
	beforeLoad: async () => {
		const { user } = useAuthStore.getState();
		if (user?.userType === "BUYER") {
			return redirect({ to: "/get-started" });
		}
	},
	component: RouteComponent
});

function RouteComponent() {
	return (
		<div className="h-screen w-screen bg-primary">
			<div className="flex h-full w-full flex-col items-center justify-center">
				<h1 className="text-4xl font-bold">Onboarding</h1>
			</div>
		</div>
	);
}
